export default __webpack_public_path__ + "static/media/logo.a6a7894c.png";